import { ESIA_TYPE, getLoginUrl, LOGIN_TYPE } from '@sravni/utils/lib/auth';

export const getIncomeConfirmationEsiaAuthUrl = () =>
  getLoginUrl({
    returnUrl: new URL(window.location.href).toString(),
    loginType: LOGIN_TYPE.ESIA,
    esiaType: ESIA_TYPE.OPTIONAL,
  });
